export const CHANGE_NAME = "CHANGE_NAME"
export const USER_DETAILS = "USER_DETAILS"
export const IS_AUTHENTICATED = "IS_AUTHENTICATED"